import { useSelector } from "react-redux";
import DesignHubRepository from "src/repository/DesignHubRepository";


export function useDesignHubStore() {
    const countryList = useSelector((state) => state.entities.model_DesignHub.countryList)

    let data = {
        countryList
    };

    let fetch = {};
    
    let set = {
        register_user: async (params) => {
            return await new DesignHubRepository().registerUser(params);
        }

    };
    return [data, fetch, set]
}